import React from 'react';
import renderHTML from 'react-render-html';

const TrustSection = ({ title, subTitle }) => {
	return (
		<section className="row trusted">
			<div className="col">
				<h2>{ renderHTML(title) }</h2>
				<p>{ renderHTML(subTitle) }</p>
			</div>
		</section>
	);
};

export default TrustSection;


// WEBPACK FOOTER //
// ./src/pages/category/common/TrustSection.js